export default "__VITE_ASSET__Cm9puc0v__"